import { render, staticRenderFns } from "./InfosProfitSection.vue?vue&type=template&id=f929623a"
import script from "./InfosProfitSection.vue?vue&type=script&lang=js"
export * from "./InfosProfitSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports